import { siteConfig } from "@/lib/siteConfig";
import { ArrowUpRight } from "lucide-react";

const captions = [
  { label: "Bordir Logo Kemeja", media: "Kemeja Katun" },
  { label: "Seragam Kantor", media: "Drill" },
  { label: "Topi Event", media: "Trucker Cap" },
  { label: "Bordir Handuk", media: "Handuk Hotel" },
  { label: "Bordir Boneka", media: "Souvenir" },
  { label: "Jaket Komunitas", media: "Fleece" },
];

export default function Gallery() {
  const images = siteConfig.images.gallery;
  return (
    <section
      id="galeri"
      data-testid="gallery-section"
      className="py-20 md:py-28 bg-muted relative"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="text-xs sm:text-sm uppercase tracking-[0.25em] font-semibold text-primary">
              Galeri Portfolio
            </span>
            <h2
              data-testid="gallery-headline"
              className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight font-semibold text-foreground"
            >
              Beberapa hasil yang sudah kami kerjakan.
            </h2>
            <p className="mt-4 font-body text-base text-muted-foreground leading-relaxed">
              Dari logo perusahaan, seragam tim, hingga bordir di handuk dan boneka — setiap proyek diperlakukan dengan standar yang sama.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {images.map((src, idx) => (
            <figure
              key={idx}
              data-testid={`gallery-item-${idx}`}
              className={`group relative overflow-hidden rounded-xl border border-border bg-secondary aspect-[4/5]
              }`}
            >
              <img
                src={src}
                alt={captions[idx % captions.length].label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  e.currentTarget.parentElement.style.background =
                    "linear-gradient(135deg,#E5D9C5,#C97A4E)";
                }}
              />
              {/* Caption overlay */}
              <figcaption className="absolute inset-x-0 bottom-0 p-4 md:p-5 bg-gradient-to-t from-[#2C2621]/85 via-[#2C2621]/40 to-transparent">
                <div className="flex items-end justify-between gap-3">
                  <div>
                    <div className="text-xs uppercase tracking-widest text-[#E8B796] font-semibold">
                      {captions[idx % captions.length].media}
                    </div>
                    <div className="font-heading text-base md:text-lg font-semibold text-white mt-0.5">
                      {captions[idx % captions.length].label}
                    </div>
                  </div>
                  <ArrowUpRight className="w-5 h-5 text-white/70 transition-transform group-hover:-translate-y-1 group-hover:translate-x-1" />
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
